import * as types from '../types'

const initialState = {
    curriculums: {}, // Keyed by course_id
    loading: false,
    error: null
}

const courseCurriculumReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_CURRICULUM_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }

        case types.FETCH_CURRICULUM_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                curriculums: {
                    ...state.curriculums,
                    [action.payload.courseId]: action.payload.curriculum
                }
            }

        case types.FETCH_CURRICULUM_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case types.CLEAR_CURRICULUM_ERROR:
            return {
                ...state,
                error: null
            }

        default:
            return state
    }
}

export default courseCurriculumReducer
